import { useContext } from 'react';

import { useQuery } from '@tanstack/react-query';
import uniqBy from 'lodash/uniqBy';

import type { ViewDefinition } from '@cognite/sdk';

import type { ViewMappingReference } from '../../features/app-config/cdm-types';
import type { QueryMeta } from '../query-client';
import { QueryKeys } from '../../utils/queryKeys';

import { UseGetViewsByReferencesContext } from './cdm-use-get-views-by-references.context';

export const useGetViewsByReferences = (
  viewReferences: ViewMappingReference[],
  enabled?: boolean
) => {
  const { useAuthContext } = useContext(UseGetViewsByReferencesContext);
  const { client } = useAuthContext();
  return useQuery<ViewDefinition[] | undefined>({
    queryKey: [QueryKeys.VIEWS, viewReferences],
    queryFn: async () => {
      const viewReferencesWithoutType: ViewMappingReference[] = uniqBy(
        viewReferences.map((view) => ({
          externalId: view.externalId,
          space: view.space,
          version: view.version,
        })),
        (view) => `${view.externalId}-${view.space}-${view.version}`
      );
      const { items: views } = await client.views.retrieve(
        viewReferencesWithoutType
      );
      return views;
    },
    enabled: viewReferences.length > 0 && enabled,
    meta: {
      error: { toast: { body: 'Failed to fetch views.' } },
    },
  });
};
